<template>
    <div class="container">
        <div class="header">
            <div class="title">物流详情</div>
            <div class="close" @click="$router.back()">
                <van-icon name="cross" />
            </div>
        </div>
        <div class="logistics" v-watermark>
            <van-empty :description="logistics.none" v-if="logistics.none" />
            <div class="logistics-box" v-else>
                <div class="no" v-if="logistics.logisticsNo"> <span>{{logistics.shipperName }}:</span> {{ logistics.logisticsNo }} <span class="copy" @click="copy(logistics.logisticsNo)">复制</span></div>
                <div class="logistics-list">
                    <div class="item" v-for="(item, index) in logistics.list" :key="index">
                        <div class="dot"></div>
                        <div class="item-box">
                            <div class="name">{{ item.status }}</div>
                            <div class="time">{{ item.time }}</div>
                            <div class="content">{{ item.context }}</div>
                        </div>
                    </div>
                    <div class="item" v-if="!logistics.list.length">
                        <div class="dot"></div>
                        <div class="item-box">
                            <div class="name">待揽收</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getLogistics } from '@/api/index'
export default {
    data() {
        return {
            logistics: {
                list: [],
                logisticsNo: '',
                none: '',
                shipperName:''
            }
        }
    },
    filters:{
        shipperName(com){
           if(com=='shunfeng'){
             return '顺丰速运'
           }else if(com=='baishi'){
              return '百世快递'
           }else{
            return '德邦快递'
           }
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.onDataGet()
            this.logistics.shipperName = this.$route.query.shippingCompName
        },
        copy(value) {
            const input = document.createElement("input");
            input.value = value;
            document.body.appendChild(input);
            input.select();
            document.execCommand("Copy");
            document.body.removeChild(input);
            this.$toast("复制成功");
        },
        onDataGet() {
            getLogistics({ askNo: this.$route.query.askNo }).then(({ data }) => {
                if (data) {
                    let dataList = JSON.parse(data)
                    this.logistics.list = dataList.data || [];
                    this.logistics.logisticsNo = dataList.nu && dataList.nu;
                   
                } else {
                    this.logistics.none = '暂无物流信息';
                }
            }).catch(({ message }) => {
                this.logistics.none = '暂无物流信息';
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    background: #fff;
    min-height: 100vh;

    .header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;

        .title {
            font-weight: bold;
            font-size: 18px;
        }
    }

    .logistics {
        height: calc(100vh - 60px);
        overflow-y: auto;

        .no {
            margin-bottom: 20px;
        }

        &-box {
            padding: 10px 20px;

            .item {
                position: relative;
                display: flex;

                .dot {
                    flex: none;
                    width: 15px;
                    height: 15px;
                    background: #d7d7d7;
                    border-radius: 50px;
                    margin-right: 20px;

                    &::before {
                        content: "";
                        position: absolute;
                        left: 7px;
                        top: 16px;
                        bottom: 0;
                        z-index: 0;
                        border-left: 3px dotted #d7d7d7;
                    }
                }

                &:last-child {
                    .dot {
                        &::before {
                            display: none;
                        }
                    }
                }

                &-box {
                    padding-bottom: 20px;

                    .name {
                        font-weight: bold;
                        font-size: 14px;
                        margin-top: -3px;
                    }

                    .time {
                        margin-top: 10px;
                        color: #999;
                        font-size: 12px;
                    }

                    .content {
                        margin-top: 10px;
                        word-break: break-all;
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
.copy {
    margin-left: 8px;
    padding: 4px;
    border-radius: 4px;
    color: #fff;
    display: inline-block;
    background: rgb(25, 137, 250);
    font-size: 14px;
    font-weight: normal;
}
</style>